module.exports = __webpack_public_path__ + "img/subtract.440a0a9c.svg";